import React, { memo } from 'react';
import { ChipTypeTokens, } from '@voltmoney/schema';
import ChipBase from './Chip.base';
import ThemeProvider from '@voltmoney/theme';
/**
 * Primary UI component for user interaction
 */
const Chip = ({ type = ChipTypeTokens.SMALL_UNSELECTED, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const theme = ThemeProvider.getTheme();
    const chipThemeProps = theme.chip[type];
    return (React.createElement(ChipBase, { ...props, ...chipThemeProps }));
};
export default memo(Chip);
export { Chip };
